import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { MessageTypeSchema } from 'modules/frequencyManagement/contexts/FormProvider';
import { MessageTypeRow } from 'modules/frequencyManagement/components/messageType/MessageTypeRow';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { NoneExistEmptyState } from './NoneExistEmptyState';
import { NoResultsEmptyState } from './NoResultsEmptyState';

export const Wrapper = styled.div`
  & > *:not(:first-child) {
    border-top: ${spacing.single} solid ${colors.borderPrimarySubtle};
  }
`;

export const CardBody = ({
  hasMessageTypes,
  messageMedium,
  visibleMessageTypes,
}: {
  hasMessageTypes: boolean;
  messageMedium: SupportedMediums;
  visibleMessageTypes: MessageTypeSchema[];
}) => {
  if (!hasMessageTypes) return <NoneExistEmptyState messageMedium={messageMedium} />;

  if (hasMessageTypes && visibleMessageTypes.length === 0) return <NoResultsEmptyState />;

  return (
    <Wrapper>
      {visibleMessageTypes.map((messageType: MessageTypeSchema) => (
        <MessageTypeRow
          key={messageType.id}
          messageType={messageType}
          messageMedium={messageMedium}
        />
      ))}
    </Wrapper>
  );
};
